// import React, { useEffect, useState } from "react";
// import { Modal, List, Typography, Divider, Spin } from "antd";
// import { useNavigate } from "react-router-dom";
// import { post } from "../services/services";
// import { ApiURL } from "../services/apiConstants";

// const NotificationModal = ({
//   isModalOpen,
//   setIsModalOpen,
//   handleUnreadCountChange,
// }) => {
//   const navigate = useNavigate();

//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [hasFetched, setHasFetched] = useState(false); // ✅ guard flag

//   // ================= FETCH NOTIFICATIONS (SINGLE SOURCE) =================
//   const fetchNotifications = async () => {
//     setLoading(true);
//     try {
//       const res = await post(
//         ApiURL.demo_notification_listing,
//         new FormData()
//       );

//       if (res?.status === true) {
//         const list = res?.notifications || [];
//         setNotifications(list);
//         handleUnreadCountChange(list.length);
//         setHasFetched(true); // ✅ mark as fetched
//       }
//     } catch (error) {
//       console.error("Notification fetch error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= CLICK HANDLER =================
//   const handleNotificationClick = async (notification) => {
//     setLoading(true);

//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("demo_request_id", notification.id);

//       const res = await post(
//         ApiURL.demo_notification_listing, // SAME API
//         FORM_DATA
//       );

//       if (res?.status === true) {
//         await fetchNotifications(); // refresh after removal
//         navigate("/demo-requests");
//         setIsModalOpen(false);
//       }
//     } catch (error) {
//       console.error("Notification click error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= INITIAL LOAD (ONLY ONCE) =================
//   useEffect(() => {
//     if (!hasFetched) {
//       fetchNotifications(); // 🔔 single API call on page load
//     }
//   }, [hasFetched]);

//   return (
//     <Modal
//       title="Notifications"
//       open={isModalOpen}
//       onCancel={() => setIsModalOpen(false)}
//       footer={null}
//       style={{ top: "60px", right: "220px", position: "fixed" }}
//     >
//       {loading ? (
//         <Spin size="large" />
//       ) : notifications.length === 0 ? (
//         <Typography.Text
//           type="secondary"
//           style={{ textAlign: "center", display: "block", padding: 20 }}
//         >
//           No notifications
//         </Typography.Text>
//       ) : (
//         <div style={{ maxHeight: 400, overflowY: "auto" }}>
//           <List
//             dataSource={notifications}
//             renderItem={(notification) => (
//               <List.Item
//                 key={notification.id}
//                 onClick={() => handleNotificationClick(notification)}
//                 style={{
//                   background: "#e6f7ff",
//                   padding: "12px 16px",
//                   borderRadius: 8,
//                   marginBottom: 8,
//                   cursor: "pointer",
//                 }}
//               >
//                 <List.Item.Meta
//                   title={
//                     <Typography.Text strong>
//                       {notification.name}
//                     </Typography.Text>
//                   }
//                   description={`Received at ${new Date(
//                     notification.time
//                   ).toLocaleString()}`}
//                 />
//               </List.Item>
//             )}
//           />
//         </div>
//       )}
//       <Divider />
//     </Modal>
//   );
// };

// export default NotificationModal;

import React, { useEffect, useState } from "react";
import { Modal, List, Typography, Divider, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../services/services";
import { ApiURL } from "../services/apiConstants";

const NotificationModal = ({
  isModalOpen,
  setIsModalOpen,
  handleUnreadCountChange,
}) => {
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false); // ✅ guard flag

  // ================= FETCH NOTIFICATIONS (SINGLE SOURCE) =================
  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await post(
        ApiURL.demo_notification_listing,
        new FormData()
      );

      if (res?.status === true) {
        const categories = res?.notifications || {};
        
        // Flatten categories into a single list with type property
        const flattened = [
          ...(categories.demo_requests || []).map(item => ({ ...item, type: 'demo_requests' })),
          ...(categories.bugs || []).map(item => ({ ...item, type: 'bugs' })),
          ...(categories.change_requests || []).map(item => ({ ...item, type: 'change_requests' })),
          ...(categories.feature_requests || []).map(item => ({ ...item, type: 'feature_requests' })),
          ...(categories.feedbacks || []).map(item => ({ ...item, type: 'feedbacks' })),
          ...(categories.general_inquiries || []).map(item => ({ ...item, type: 'general_inquiries' })),
        ];

        // Sort by time descending
        flattened.sort((a, b) => new Date(b.time) - new Date(a.time));

        setNotifications(flattened);
        handleUnreadCountChange(flattened.length);
        setHasFetched(true); // ✅ mark as fetched
      }
    } catch (error) {
      console.error("Notification fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ================= CLICK HANDLER =================
  const handleNotificationClick = async (notification) => {
    setLoading(true);

    try {
      const FORM_DATA = new FormData();
      
      let redirectPath = "";
      
      switch (notification.type) {
        case "demo_requests":
          FORM_DATA.append("demo_request_id", notification.id);
          redirectPath = "/demo-requests";
          break;
        case "bugs":
          FORM_DATA.append("bug_id", notification.id);
          redirectPath = "/bugs";
          break;
        case "change_requests":
          FORM_DATA.append("change_request_id", notification.id);
          redirectPath = "/change-requests";
          break;
        case "feature_requests":
          FORM_DATA.append("feature_request_id", notification.id);
          redirectPath = "/feature-requests";
          break;
        case "feedbacks":
          FORM_DATA.append("feedback_id", notification.id);
          redirectPath = "/feedback";
          break;
        case "general_inquiries":
          FORM_DATA.append("general_inquiry_id", notification.id);
          redirectPath = "/general-enquiry";
          break;
        default:
          break;
      }

      const res = await post(
        ApiURL.demo_notification_listing, // SAME API
        FORM_DATA
      );

      if (res?.status === true) {
        await fetchNotifications(); // refresh after removal
        if (redirectPath) navigate(redirectPath);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Notification click error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ================= INITIAL LOAD (ONLY ONCE) =================
  useEffect(() => {
    if (!hasFetched) {
      fetchNotifications(); // 🔔 single API call on page load
    }
  }, [hasFetched]);

  return (
    <Modal
      title="Notifications"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      style={{ top: "60px", right: "220px", position: "fixed" }}
    >
      {loading ? (
        <Spin size="large" />
      ) : notifications.length === 0 ? (
        <Typography.Text
          type="secondary"
          style={{ textAlign: "center", display: "block", padding: 20 }}
        >
          No notifications
        </Typography.Text>
      ) : (
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          <List
            dataSource={notifications}
            renderItem={(notification) => (
              <List.Item
                key={`${notification.type}-${notification.id}`}
                onClick={() => handleNotificationClick(notification)}
                style={{
                  background: "#e6f7ff",
                  padding: "12px 16px",
                  borderRadius: 8,
                  marginBottom: 8,
                  cursor: "pointer",
                }}
              >
                <List.Item.Meta
                  title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography.Text strong>
                        {notification.name || notification.title || "New Message"}
                      </Typography.Text>
                      <Typography.Text type="secondary" style={{ fontSize: '12px', textTransform: 'capitalize' }}>
                        {notification.type.replace('_', ' ')}
                      </Typography.Text>
                    </div>
                  }
                  description={`Received at ${new Date(
                    notification.time
                  ).toLocaleString()}`}
                />
              </List.Item>
            )}
          />
        </div>
      )}
      <Divider />
    </Modal>
  );
};

export default NotificationModal;
